import { translate } from "~/core/ts/util/translate"

export function useStaticLinks() {
  const runtime = useRuntimeConfig()

  const manageVoucherLoginLink = translate(runtime.public.urls.static.manageVoucherLoginByLang)
  const manageVoucherFormLink = translate(runtime.public.urls.static.manageVoucherFormByLang)
  const giftCardLink = translate(runtime.public.urls.static.giftCardByLang)
  const giftCardCheckoutLink = translate(runtime.public.urls.static.giftCardCheckoutByLang)
  const redeemGetAwayLink = translate(runtime.public.urls.static.redeemGetAwayByLang)
  const contactLink = translate(runtime.public.urls.static.contactByLang)
  const legalNoticeLink = translate(runtime.public.urls.static.legalNoticeByLang)
  const privacyPolicyLink = translate(runtime.public.urls.static.privacyPolicyByLang)
  const changeAndRefundLink = translate(runtime.public.urls.static.changeAndRefundByLang)
  const generalConditionLink = translate(runtime.public.urls.static.generalConditionByLang)
  const cookiePolicyLink = translate(runtime.public.urls.static.cookiePolicyByLang)
  const bookingConfirmationLink = translate(runtime.public.urls.static.bookingConfirmationByLang)
  const bookingCheckoutLink = translate(runtime.public.urls.static.bookingCheckoutByLang)

  return {
    manageVoucherLoginLink,
    manageVoucherFormLink,
    giftCardLink,
    giftCardCheckoutLink,
    redeemGetAwayLink,
    contactLink,
    legalNoticeLink,
    privacyPolicyLink,
    changeAndRefundLink,
    generalConditionLink,
    cookiePolicyLink,
    bookingConfirmationLink,
    bookingCheckoutLink,
  }
}
